export default {"src":"/_next/static/media/tinkoff-logo.83917ee6.svg","height":29,"width":88};